import { AlwaysTrue } from '@vendasta/automata';
import { RuleInterface } from '@vendasta/automata/lib';

export function NoRules(): RuleInterface[] {
  return [new AlwaysTrue('').toRuleInterface()];
}
